import DialogProfilingRefresh from '~/components/dialog/profiling/DialogProfilingRefresh.vue';

export const useDialogRefreshProfiling = () => {
  const dialog = useDialogStore();
  const profile = useProfileStore();
  const route = useRoute();
  const cancelEvent = createEventHook<any>();
  const open = () => {
    dialog.lockOnSystemLevel();
    dialog.open(DialogProfilingRefresh, {
      level: DialogLevel.System,
      htmlText: profile.refreshProfiling.htmlMessage,
      textOk: 'Démarrer',
      align: 'center',
      mandatory: profile.refreshProfiling.mandatory,
      confirmButton: profile.refreshProfiling.confirmButton,
      dismissButton: profile.refreshProfiling.dismissButton,
      onConfirm: () => {
        dialog.close();
        dialog.unlock();
        navigateTo('/profiling/by-step?continue=' + route.fullPath);
      },
      onClose: () => {
        dialog.close();
        dialog.unlock();
        cancelEvent.trigger();
      },
    });
  };

  return {
    open,
    onCancel: cancelEvent.on,
  };
};
